import React from 'react';
import PropTypes from 'prop-types';
import {Dialog, FlatButton, Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../components/common/Error/Error";
import Loading from "../../components/common/Loading/Loading";
import {fetchApp, getSubscribedPush, resetSubscribedPush} from '../../store/apps/actions';
import style from '../../styles/styles';
import styles from './AddPagePage.css';
import {postPage} from "../../store/pages/actions";
import PageForm from "../../components/page/PageForm";
import {dispatchInfo} from "../../store/infos/actions";
import {PAGE_PAGE} from "../../constants/routes";
import withTranslation from "../../hoc/withTranslation";

export class AddPagePage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {};

    state = {
        shouldCreateNew: false,
        title: null,
        pushModalOpened: false,
        waitingFormProps: null
    };

    componentWillMount() {
        this.fetchApplication();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.page) {

            if (this.state.shouldCreateNew) {
                this.props.dispatchInfo(nextProps.page.title + ' saved');
            }

            if (!this.state.shouldCreateNew) {
                let url = PAGE_PAGE
                    .replace(':appId', this.props.app.id)
                    .replace(':pageId', nextProps.page.id);
                this.props.history.push(url);
            }
        }

        if (this.state.shouldCreateNew) {
            this.setState({shouldCreateNew: false});
        }
    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        if (formProps.push_entity) {
            let pushFormProps = {
                message: formProps.title,
                groups: ["page"],
                langs: ["fr", "en"]
            };
            await this.props.getSubscribedPush(this.props.app.id, pushFormProps);
            this.handleOpenPushModal(formProps);
        } else {
            await this.handlePostData(formProps)
        }
    };

    handleOpenPushModal = (formProps) => {
        this.setState({
            pushModalOpened: true,
            waitingFormProps: formProps
        });
    };

    handleClosePushModal = () => {
        this.setState({
            pushModalOpened: false,
            waitingFormProps: null
        });
        this.props.resetSubscribedPush();
    };

    handlePostData = (formProps) => {
        if (formProps === null && this.state.waitingFormProps === null) {
            return;
        }
        if (formProps === null) {
            formProps = this.state.waitingFormProps;
        }
        this.props.postPage(this.props.app.id, formProps, this.props.lang);
    };

    handleFormReset = () => {
        this.setState({
            title: null,
            shouldCreateNew: true
        });
    };

    // Render

    renderPushDialog() {
        const actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                primary={false}
                onClick={this.handleClosePushModal}
            />,
            <FlatButton
                label={this.props.t('generic.push')}
                primary={true}
                onClick={this.handlePostData}
            />
        ];

        return (
            <Dialog
                title={this.props.t('generic.push_notification')}
                actions={actions}
                modal={false}
                open={this.state.pushModalOpened}
                onRequestClose={this.handleClosePushModal}
            >
                <div dangerouslySetInnerHTML={{
                    __html:
                        this.props.t('module.push.push_confirmation', {
                            name: this.props.app.name
                        })
                }} />

                {this.props.subscribedToPush &&
                <div>
                    <div dangerouslySetInnerHTML={{
                        __html:
                            this.props.t('module.push.device_count', {
                                count: this.props.subscribedToPush
                            })
                    }} />
                </div>
                }
            </Dialog>
        )
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>
                        {this.props.t('module.page.page_add', {name: this.props.app.name})}
                    </h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.page.new_page')}
                                </Subheader>
                                <div style={style.paper}>
                                    <PageForm
                                        onFormReset={this.handleFormReset}
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                        app={this.props.app}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                    {this.renderPushDialog()}
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.pages.pending,
        error: state.apps.error,
        page: state.pages.currentPage,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.pages.sending,
        types: state.types.content,
        subscribedToPush: state.apps.subscribedToPush,
        customFields: state.customFields.content
    };
}

export default connect(mapStateToProps, {
    postPage,
    getSubscribedPush,
    resetSubscribedPush,
    fetchApp,
    dispatchInfo,
})(withTranslation(AddPagePage));



// WEBPACK FOOTER //
// src/containers/page/AddPagePage.js